module.exports = __webpack_public_path__ + "img/logoname.afc266d1.png";